import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => {
    return state[NAME];
};

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getIsOpenModal = createSelector(
    getModel,
    (model) => model.isOpenModal,
);

export const getIsNewRecord = createSelector(
    getModel,
    (model) => model.isNewRecord,
);

export const getUsers = createSelector(getModel, (model) => model.users);

export const getUsersData = createSelector(getUsers, (model) => model.data);

export const getContact = createSelector(getModel, (model) => model.contact);

export const getContactErrors = createSelector(
    getContact,
    (contact) => contact.errors,
);

export const getEmails = createSelector(
    getModel,
    (model) => model.initialValues.emails,
);

export const getPhoneCodes = createSelector(
    getModel,
    (model) => model.phoneCodes,
);

export const getIsFetchingPhoneCodes = createSelector(
    getPhoneCodes,
    (phoneCodes) => phoneCodes.isFetching,
);

export const getPhoneCodesData = createSelector(
    getPhoneCodes,
    (phoneCodes) => phoneCodes.data || [],
);

export const getPhoneCodeErrors = createSelector(
    getPhoneCodes,
    (phoneCodes) => phoneCodes.errors || [],
);
